<template>
    <v-container fluid d-flex class="fill-height">
        <v-col cols="3" class="fill-height">
            <v-list flat class="pa-0 fill-height scrollable align-start">
                <v-list-item-group color="primary" v-model="selectedPodcast" @change="getEpisodes">
                    <v-list-item v-for="(podcast, i) in podcasts" :key="i" :value="podcast">
                        <v-list-item-title v-text="podcast.title"></v-list-item-title>
                        <v-list-item-action>
                            <v-icon @click="removePodcastFromBuild(podcast)">mdi-trash-can-outline</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-col>
        <v-col cols="3" class="fill-height" v-if="selectedPodcast">
            <v-list flat class="pa-0 fill-height scrollable align-start">
                <v-list-item-group color="primary" v-model="selectedEpisode">
                    <v-list-item v-for="(episode, i) in episodes" :key="i" :value="episode">
                        <v-list-item-content>
                            <v-list-item-title v-text="episode.title"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-col>
        <v-col cols="6">
            <div class="pa-0 fill-height" v-if="selectedEpisode">
                <div class="text-h5 text-center">{{ selectedEpisode.title }}</div>
                <div class="text-h6 text-center">{{ selectedPodcast.title }}</div>
                <v-img class="mx-auto" max-width="500px" width="75%" :src="$directoryApi.podcasts.artworkRoute(selectedPodcast.id)"></v-img>
                <div class="text-center"><audio controls :src="$directoryApi.episodes.audioRoute(selectedEpisode.id)" /></div>
            </div>
        </v-col>
        <v-btn color="primary" dark fixed bottom right fab @click="addPodcastToBuild">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <appleSearch ref="appleSearch" />
    </v-container>
</template>

<script>
import appleSearch from '@/components/appleSearch'

export default {
    components: {
        appleSearch,
    },
    props: {
        buildKey: {
            type: String,
        },
    },
    data() {
        return {
            podcasts: [],
            selectedPodcast: null,
            episodes: [],
            selectedEpisode: null,
        }
    },
    async mounted() {
        this.initialize()
        await this.getPodcasts()
    },
    methods: {
        initialize() {},
        async getPodcasts() {
            try {
                var response = await this.$directoryApi.podcasts.all(this.buildKey)
                this.podcasts = response.data
            } catch (err) {
                console.log(err)
            }
        },
        async getEpisodes() {
            if (!this.selectedPodcast) return
            try {
                var response = await this.$directoryApi.podcasts.one(this.selectedPodcast.id)
                this.episodes = response.data.episodes
            } catch (err) {
                console.log(err)
            }
        },
        async addPodcastToBuild() {
            var collectionId = await this.$refs.appleSearch.pop()
            if (!collectionId) return
            try {
                var response = await this.$directoryApi.podcasts.addToBuild(this.buildKey, collectionId)
                this.podcasts.push(response.data)
            } catch (err) {
                console.log(err)
            }
        },
        async removePodcastFromBuild(podcast) {
            try {
                await this.$directoryApi.podcasts.removeFromBuild(this.buildKey, podcast.collectionId)
                this.podcasts.splice(this.podcasts.indexOf(podcast), 1)
            } catch (err) {
                console.log(err)
            }
        },
    },
}
</script>

<style scoped>
.scrollable {
    overflow: auto;
}

.v-list-item >>> .v-icon {
    opacity: 0;
    transition: opacity 1s;
}

.v-list-item:hover >>> .v-icon {
    opacity: 1;
}
</style>
